import type { VariantProps } from "class-variance-authority";
import { cloneElement, type ReactElement } from "react";

import { cn } from "../../utils";
import { featureIconStyles, iconStyles, OUTLINE_VARIANTS } from "./style";

export type FeatureIconProps = {
  className?: string;
  children: ReactElement<{ className?: string }>;
} & VariantProps<typeof featureIconStyles>;

const FeatureIcon = ({
  className,
  size = "md",
  variant = "light-circle-outline-primary",
  children,
}: FeatureIconProps) => {
  return (
    <div className={cn(featureIconStyles({ size, variant }), className)}>
      {cloneElement(children, {
        className: cn(
          iconStyles({
            size,
            style: variant && (OUTLINE_VARIANTS as string[]).includes(variant) ? "outline" : "solid",
          }),
          children.props.className
        ),
      })}
    </div>
  );
};

export default FeatureIcon;
